<template>
  <AppHeaderDropdown right no-caret v-if="(notifcounter>0)">
    <template slot="header">
      <i class="fa fa-bell-o"></i>      
      <span class="badge badge-pill badge-danger">{{this.notifcounter}}</span>    
    </template>

    <template slot="dropdown">
      <b-dropdown-item v-for="notif in notifications" :key="notif.notifName" @click="notifAction(notif)"> <span class="badge badge-pill badge-danger">{{notif.counter}}</span> {{notif.notifName}}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<style lang="scss" scoped>
.thin-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.dropdown-item {
  padding: 8px 20px;
  color: #73818f;
}
</style>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import auth from "../apis/auth.js";

export default {
  components: {
    AppHeaderDropdown
  },
  computed: {
    notifications(){
      return this.$store.state.notifications.filter(n => n.counter>0);
    },
  },
  data: () => {
    return {
    notifcounter:0
    };
  },
  created: async function() {
    // this.opentasks = [
    //   { taskkey:"1", taskname: "Annual Budget Request", createdby: "Adi Ibrahim" },
    //   { taskkey:"2", taskname: "Project Budget Request - Wisma Kayla", createdby: "Adi Ibrahim" },
    //   { taskkey:"3", taskname: "Annual Leave", createdby: " Eko Purnomo" }
    // ];
    this.user = await auth.me();
    setTimeout(() => {
      // this.notifcounter= (this.notifications.TaskCount + this.notifications.MrCount + this.notifications.PrCount + this.notifications.RcvCount);    
      this.notifcounter = this.notifications.reduce((jml, item) => {
                        jml += item.counter;
                        return jml;
                    },0);

    }, 1000);
  },
  watch:{
    notifications: function(newval) {
      // this.notifcounter= (newval.TaskCount + newval.MrCount + newval.PrCount + newval.RcvCount);
      this.notifcounter = newval.reduce((jml, item) => {
                        jml += item.counter;
                        return jml;
                    },0);
    },    
  },
  methods: {
    notifAction(notif){
      if (notif.routerName=='loan.requisition') {
        this.$router.push({ name: notif.routerName });
      } else {
        if (process.env.VUE_APP_MYAPP){
          window.open(`${process.env.VUE_APP_MYAPP}${notif.url}`, "_self");
          // location.href = process.env.VUE_APP_MYAPP;
        }
          // window.open("/procurement/#/procurement/receiving?id=testing", "_self");
          // console.log(this.$route.query); //in receiving.vue
      }
    },
    showTask() {
      console.log('hit Pending Task Notification');
    }
  }

};
</script>
